/** Conteúdo da página de contato (contato.v1). */

const str = (v) => String(v ?? "").trim();

function parseMaybe(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

const link = (o) => {
  const label = str(o?.label);
  const href = str(o?.href);
  if (!label && !href) return null;
  return { label, href };
};

const channel = (o) => {
  if (!o || typeof o !== "object") return undefined;
  const title = str(o.title);
  const description = str(o.description);
  const label = str(o.label);
  const href = str(o.href);
  const ctaLabel = str(o.ctaLabel);
  if (!title && !description && !label && !href && !ctaLabel) return undefined;
  return {
    title: title || undefined,
    description: description || undefined,
    label: label || undefined,
    href: href || undefined,
    ctaLabel: ctaLabel || undefined,
  };
};

export function emptyContatoPage() {
  return sanitizeContatoPage({
    format: "contato.v1",
    meta: { title: "", description: "" },
    hero: { title: "", subtitle: "", ctaLinks: [] },
    channels: {
      sectionTitle: "",
      sac: {},
      pcd: {},
      whatsapp: {},
      agencies: {},
      faq: {},
    },
    form: { title: "", description: "", sidebarTitle: "", sidebarNote: "" },
    faqTitle: "",
  });
}

export function sanitizeContatoPage(src) {
  const v = src && typeof src === "object" ? src : {};
  const metaIn = v.meta && typeof v.meta === "object" ? v.meta : {};
  const heroIn = v.hero && typeof v.hero === "object" ? v.hero : {};
  const channelsIn = v.channels && typeof v.channels === "object" ? v.channels : {};
  const formIn = v.form && typeof v.form === "object" ? v.form : {};

  const ctaLinks = Array.isArray(heroIn.ctaLinks)
    ? heroIn.ctaLinks.map(link).filter(Boolean)
    : [];

  return {
    format: "contato.v1",
    meta: {
      title: str(metaIn.title),
      description: str(metaIn.description),
    },
    hero: {
      title: str(heroIn.title),
      subtitle: str(heroIn.subtitle),
      ctaLinks,
    },
    channels: {
      sectionTitle: str(channelsIn.sectionTitle) || undefined,
      sac: channel(channelsIn.sac),
      pcd: channel(channelsIn.pcd),
      whatsapp: channel(channelsIn.whatsapp),
      agencies: channel(channelsIn.agencies),
      faq: channel(channelsIn.faq),
    },
    form: {
      title: str(formIn.title) || undefined,
      description: str(formIn.description) || undefined,
      sidebarTitle: str(formIn.sidebarTitle) || undefined,
      sidebarNote: str(formIn.sidebarNote) || undefined,
    },
    faqTitle: str(v.faqTitle) || undefined,
  };
}

export function parseContatoPageFromContent(contentData) {
  const raw = parseMaybe(contentData?.conteudo_json);
  if (raw?.format === "contato.v1") {
    return sanitizeContatoPage(raw);
  }
  return emptyContatoPage();
}
